module.exports = __webpack_public_path__ + "templates/cart-failure.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cart/templates/cart-failure.html
// module id = 1drf
// module chunks = 1